import { render, staticRenderFns } from "./forgetForm.vue?vue&type=template&id=5f7f586b&scoped=true&"
import script from "./forgetForm.vue?vue&type=script&lang=js&"
export * from "./forgetForm.vue?vue&type=script&lang=js&"
import style0 from "./forgetForm.vue?vue&type=style&index=0&id=5f7f586b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7f586b",
  null
  
)

export default component.exports